export const API_ENDPOINTS = {
  userLogout: 'vings-auth/b2b/logout',
  refreshToken: 'vings-auth/b2b/refresh-token',
  ebhRecommender: '/ebh-recommender/api/orchestrator/fetch',
  cmsData: 'vhc-wrapper/personalization/cms-config',
  login: '/vings-auth/b2b/login-v2',
  changePassword: '/vings-auth/b2b/password-reset/change',
  executeJob: 'vhc-wrapper/reports/execute-job',
  getStatus: 'vhc-wrapper/reports/v2/get_status',
  policyList: 'policy/broker/list',
  superset: 'superset',
  getUserContactWithFinYears: 'user/details/contact-with-finyears',
  activeCashless: 'api/active-preauth/list',
  unifiedSearch: 'vhc-wrapper/unified-search',
  eventLogs: 'api/event-details',
  cardList: 'api/hr/ecard/details',
  downloadEcard: 'api/hr/ecard/download',
  downloadAllEcards: 'api/hr/ecard/consolidated-download',
  allPolicyList: 'policy/policy-seq-id-list',
  shareEcard: 'api/hr/ecard/send-ecard-via-email',
  validateOTP: '/vings-auth/b2b/validate-login-otp',
  resendOTP: '/vings-auth/b2b/resend-login-otp',
  initiateForgotPassword: '/vings-auth/b2b/password-reset/initiate',
  verifyForgotPassword: '/vings-auth/b2b/password-reset/verify',
  completeForgotPassword: '/vings-auth/b2b/password-reset/complete',
  downloadLetter: 'api/settlement-letter',
  billDetails: 'settlement/bills/details',
  flexBenefitDetails: 'api/flexi-benefit',
  reportEmbed: 'vhc-wrapper/report-embed',
  coachmarks: 'vhc-wrapper/coachmarks-ratings/save-coachmarks-hr',
  userDetails: 'vings-auth/b2b/user-details',
  recentSearches: 'vhc-wrapper/unified-search/recent',
  getDocumentFiles: 'claim/inward/preview/files-list/v2',
  getDocumentUrl: 'claim/inward/preview/document-url',
  employeeCoverDetails: 'api/employee/v2/cover-details',
  userRoles: 'vings-auth/b2b/roles-v2',
  userAssignedCities: 'user/details/assigned-cities',
};
